// Reserved PRACTICE cryptic clues — the adaptive warm-up pool. These are deliberately EASY,
// fully-explained clues sourced from Cryptonite `quick` cryptics (Times) and verified NOT to
// appear in the scored 100, so a warm-up can NEVER contaminate `firstExposure` or spoil a
// scored clue. They live OUTSIDE `CRYPTIC_PUZZLES`, so they're automatically excluded from the
// test + free-play pools — no RESERVED_IDS filter needed. Snapshot of
// analysis/cryptic/practice_cryptic.json (author/regenerate there).
//
// `llmSolveRate` is nominal (these are unscored — practice traces carry mode:'practice' and a
// `practice_*` id, and analysis excludes them); it exists only to satisfy CrypticPuzzle.

import { CrypticPuzzle } from './cryptic.data'

export const CRYPTIC_PRACTICE: CrypticPuzzle[] = [
  {
    id: 'practice_reason',
    clue: 'sense change so near (6)',
    enumeration: '(6)',
    answer: 'REASON',
    alternatives: [],
    publisher: 'Times',
    llmSolveRate: 1.0,
    definition: 'sense.',
    wordplay: "Anagram ('change') of SO NEAR = REASON.",
    defClue: 'sense',
    device: 'anagram',
  },
  {
    id: 'practice_afar',
    clue: 'some loaf around at a distance (4)',
    enumeration: '(4)',
    answer: 'AFAR',
    alternatives: [],
    publisher: 'Times',
    llmSolveRate: 1.0,
    definition: 'at a distance.',
    wordplay: "Hidden word ('some' ... of): loAF ARound contains AFAR.",
    defClue: 'at a distance',
    device: 'hidden',
  },
  {
    id: 'practice_drive',
    clue: 'doctor, i have a road up to the house (5)',
    enumeration: '(5)',
    answer: 'DRIVE',
    alternatives: [],
    publisher: 'Times',
    llmSolveRate: 1.0,
    definition: 'road up to the house (a drive).',
    wordplay: "DR ('doctor') + I'VE ('I have') = DRIVE.",
    defClue: 'road up to the house',
    device: 'charade',
  },
]
